import * as Utils from "../utils";

export const schema = [
  {
    id: "/Types/Param/Type/Object",
    type: "object",
    properties: {
      // Names another entry in the same `types` array — that is what makes a
      // type tree possible at all. Not a $ref: the target does not exist as a
      // schema document until generateSchema compiles the types at runtime.
      type: { label: "Type", type: "string", minLength: 1, default: "" },
      nullable: { label: "Empty by default?", type: "boolean", default: false },
      ...Utils.properties,
    },
    required: ["type"],
  },
];
